<div class="camera-detail-container">
  <div (click)="dismiss()" class="icon icon-btn-close"></div>
  <div class="camera-detail-type mb-4" [innerHTML]="stadiumCamera.type"></div>
  <div class="camera-detail-desc mb-4" [innerHTML]="stadiumCamera.description"></div>
  <div class="camera-detail-files" *ngIf="stadiumCamera.files.length">
    <carousel [(activeSlide)]="activeSlideIndex" [interval]="false" [noWrap]="true">
      <slide *ngFor="let file of stadiumCamera.files; let index=index">
        <app-viewer-content [isAdmin]="isAdmin" [file]="file" hide="true"></app-viewer-content> <!-- "hide" asset actions -->
      </slide>
    </carousel>
  </div>
</div>